import React from 'react';
import { PartnerComponent } from 'components';

function Partner() {
  return (
    <>
      <PartnerComponent.Header />
      <PartnerComponent.List />
    </>
  );
}

export default Partner;
